<template>
    <section class="login-section">
      <div class="login-box">
        <a href="#" class="link-block-63 w-inline-block">
          <img loading="lazy" src="@/assets/images/Rx-Pros-icon-web.png" alt="" class="image-555">
        </a>
        <div class="first-slide">
          <div class="header-sub-div">
            <div class="register-header">Forgot password?</div>
            <div class="text-block-851">Enter the email address associated with your account and we will send you a link to reset your password.</div>
          </div>
          <div class="register-form w-form">
            <form @submit.prevent="onSubmit">
              <label for="email" class="label">Email Address</label>
              <input 
                class="register-text-field w-input" 
                maxlength="256" 
                name="email" 
                data-name="Email" 
                placeholder="Enter your email" 
                type="email" 
                id="email" 
                required=""
                v-model="email"
              >
              <button 
                type="submit"
                class="submit-button-13 w-button"
                :disabled="submitted"
              >
                <div v-if="submitted">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                  </svg>
                </div>
                <div v-else>
                  Request Reset Email
                </div>
              </button>
              <div class="text-block-203">
                <router-link to="/login" class="link-12">Back to login <span class="text-span-182">-&gt;</span></router-link>
              </div>
            </form>
            <div class="w-form-done" v-if="success">
              <svg class="form-warning-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
              <div>We have emailed you a link to reset your password.</div>
            </div>
            <div class="w-form-fail" style="display:block;" v-if="err">
              <div>No user found with that email address.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'ForgotPassword',
    props: ['baseUrl'],
    data() {
      return {
        email: null,
        submitted: false,
        success: false,
        err: false
      }
    },
    methods: {
      onSubmit() {
        this.submitted = true;
        this.err = false;
        this.$axios.post(this.baseUrl + '/api/forgot-password', {
          email: this.email.toLowerCase(),
          app_src: 2,
        }).then(response => {
          if (response.data.status == 'success') {
            this.success = true;
            this.submitted = false;
          } else {
            this.submitted = false;
            this.err = true;
          }
        });
      },
    }
  }
  </script>
  
  <style scoped>
  .w-form-done {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    margin-top: 10px;
    background-color: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 6px;
    color: #92400e;
    text-align: left;
  }

  .form-warning-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    color: #f59e0b;
  }
  </style>